import React, { useState } from 'react';
import styles from './RegisterForm.module.css';
import AuthHeader from '../ui/AuthHeader/AuthHeader';
import FieldsAuth from '../ui/FieldsAuth/FieldsAuth';
import ButtonsRegister from './ButtonsRegister';
import RoleSelector from './RoleSelector';
import { NavLink, useNavigate } from 'react-router-dom';
import { register } from '../../api/Authentication';

const RegisterForm = () => {
    const [email, setEmail] = useState('');
    const [name, setName] = useState('');
    const [firstname, setFistname] = useState('');
    const [number, setNumber] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [visibility, setVisibilty] = useState(true);
    const [confirmVisibility, setConfirmVisibilty] = useState(true);
    const [address, setAddress] = useState('');
    const [company, setCompany] = useState('');
    const [check, setCheck] = useState(true);
    const [error, setError] = useState('');
    const [page, setPage] = useState(0);
    const navigate = useNavigate();

    async function handleForm(e) {
        e.preventDefault();
        setError('');

        if ((page === 1 && check) || (page === 2 && !check)) {
            if (page === 1 && password !== confirmPassword) {
                setError('Veuillez renseigner le même mot de passe');
                return;
            }
            const result = await register(email, password, firstname, name, number, check, address, company);
            if (result.success) {
                const role = result.data.role;
                const id = result.data.id;
                localStorage.setItem('user', JSON.stringify({ id, role }));
                if (role === 'trader') navigate('/trader');
                else if (role === 'client') navigate('/');
            } else {
                localStorage.removeItem('user');
                setError(result.error.message)
            }
        } else {
            setPage(page + 1);
        }
    }

    return (
        <form onSubmit={handleForm} className={styles.form}>
            <AuthHeader action='Inscription' />

            {page === 0 &&
            <>
                <FieldsAuth index='name' value={name} setValue={setName} />
                <FieldsAuth index='firstname' value={firstname} setValue={setFistname} />
                <FieldsAuth index='phone' value={number} setValue={setNumber} />
            </>}

            {page === 1 &&
            <>
                <FieldsAuth index='email' value={email} setValue={setEmail} />
                <FieldsAuth index='passwordRegister' value={password} setValue={setPassword} visibility={visibility} setVisibility={setVisibilty} />
                <FieldsAuth index='passwordAgain' value={confirmPassword} setValue={setConfirmPassword} visibility={confirmVisibility} setVisibility={setConfirmVisibilty} />
                <RoleSelector check={check} setCheck={setCheck} />
            </>}

            {page === 2 && 
            <>
                <FieldsAuth index='address' value={address} setValue={setAddress} />
                <FieldsAuth index='company' value={company} setValue={setCompany} />
            </>}

            <ButtonsRegister page={page} setPage={setPage} check={check} />
            <p className={styles.error}>{error}</p>
            <p className={styles.paragraph}>
                Ancien sur DealyGo?
                <NavLink className={styles.span} to='/login'>
                    Connectez-vous
                </NavLink>
            </p>
        </form>
    );
};

export default RegisterForm;